import React from "react";
import { ButtonProps, DialogProps as MuiDialogProps, Button, IconButton, DialogTitle } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import useText from "constants/text";
import "styled-components/macro";
import Dialog from "components/Dialog";
import { Close } from "@material-ui/icons";
import Confettis from "./Confettis";

export const useStyles = makeStyles(() =>
  createStyles({
    adventCalendarButton: {
      color: "#124379",
      width: "303px",
      height: "45px",
      fontSize: "18px",
      fontWeight: 600,
      textAlign: "center",
      top: "-3px",
      boxShadow: "0 5px 8px -4px #124379",
    },
    customCloseBtnStyle: {
      marginLeft: "auto",
      padding: "4px",
      border: "3px solid #eea82e",
      borderColor: "#eea82e",
      position: "relative",
      top: "-30px",
      left: "400px",
      color:" #eea82e !important",
      backgroundColor: "#fff !important"
    },
    adventCalendarColor: {
      color: "#eea82e !important"
    },
   


  })
);

export interface ExtendedButtonProps extends ButtonProps {
  "data-testid"?: string;
}

export interface DialogProps extends MuiDialogProps {
  image?: string;
  onClose?(): void;
  onConfirm?(): void;
  open: boolean;
}

export default function GiftDialog({ open, onConfirm, onClose, image }: DialogProps) {
  const { text } = useText();
  const classes = useStyles();


  return (
    <>
      <Confettis show={open} />
      <Dialog
      open={open}
      maxWidth="xs"
      height="600px"
      customDialogTitle={<DialogTitle style={{ borderBottom: "none" }}>
        <IconButton
          className={classes.customCloseBtnStyle}
          onClick={onClose}>
          <Close fontSize="small" className={classes.adventCalendarColor} />
        </IconButton>
      </DialogTitle>}
      customBackground={` overflow-y: inherit;
          background-color: #eea82e;
          padding:0 !important;
          text-align: center;`}
    >
      <img src={image} alt={text.all.discover_today_gift} style={{ width: "100%" }} />
      <Button variant="contained" onClick={onConfirm} className={classes.adventCalendarButton}>
        {text.all.discover_today_gift}
      </Button>
      </Dialog>
    </>
  );
}
